import { cn } from '@workspace/ui/lib/utils'
import { copy } from '../../copy/investor-copy'

const STYLES = {
  strong: 'bg-emerald-500/15 text-emerald-400',
  adequate: 'bg-amber-500/10 text-amber-400',
  weak: 'bg-red-500/10 text-red-400',
  not_on_record: 'border border-dashed border-border text-muted-foreground',
} as const

type Verdict = keyof typeof STYLES

const isVerdict = (value: string | null): value is Verdict =>
  value !== null && Object.hasOwn(STYLES, value)

/** How an area weighs, as a tinted pill with the word in it (never colour alone). */
export function VerdictPill({ verdict }: { verdict: string | null }) {
  if (!isVerdict(verdict)) {
    return (
      <span className="rounded-full border border-dashed border-border px-2 py-0.5 text-xs font-medium text-muted-foreground">
        {copy('win.notSaved')}
      </span>
    )
  }
  return (
    <span className={cn('rounded-full px-2 py-0.5 text-xs font-medium', STYLES[verdict])}>
      {copy(`verdict.${verdict}`)}
    </span>
  )
}
